import AdminPage from "../page/Admin/Products/AdminPage";

export const privateRoute = [
  {
    path: "/admin/products/:token",
    element: <AdminPage />,
  },
];
